import {Component, Inject} from '@angular/core';
import {Router, NavigationEnd, ActivatedRoute} from '@angular/router';
import {DOCUMENT} from "@angular/common";
import {TitleService} from "../../_services";
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-title',
  template: '<span></span>'
})
export class TitleComponent {
  constructor(@Inject(DOCUMENT) private document: Document, private router: Router, private route: ActivatedRoute, private titleService: TitleService) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        let currentRoute = this.route.root;
        let title = '';
        do {
          const childrenRoutes = currentRoute.children;
          currentRoute = null;
          childrenRoutes.forEach(routes => {
            if (routes.outlet === 'primary') {
              title = routes.snapshot.data.title;
              currentRoute = routes;
            }
          });
        } while (currentRoute);
        if (title !== undefined ) {
          this.titleService.setTitle(title);
        }
      });
  }
}
